/**
 * Hebrew defaultValue fallbacks for hotelprofile.multiRoom* keys.
 * Used so UI never shows raw i18n keys when locales/he.json is stale or fetch failed.
 */
export const HOTELPROFILE_MULTIROOM_HE = {
  multiRoomRegionLabel: "בחירת חדרים למספר חדרים",
  multiRoomTabsLabel: "חדרים בחיפוש",
  multiRoomStatusListLabel: "סטטוס בחירה לפי חדר",
  multiRoomCompositionOverviewTitle: "הרכבי החדרים בחיפוש",
  multiRoomOverviewLine: "חדר {{n}} — {{occupancy}}",
  multiRoomStatusNotSelected: "לא נבחר",
  multiRoomStatusSelecting: "בבחירה כעת",
  multiRoomStatusDone: "נבחר",
  multiRoomNowSelectingKicker: "השלב הנוכחי",
  multiRoomNowSelectingForRoom: "כעת בוחרים חדר עבור חדר {{n}} — {{occupancy}}",
  multiRoomJustSelected: "הבחירה לחדר {{n}} נשמרה.",
  multiRoomAllCompleteMessage: "כל החדרים הושלמו — אפשר להמשיך לפרטי האורחים.",
  multiRoomTabShort: "חדר {{n}}",
  multiRoomStatusSelected: "נבחר",
  multiRoomStatusPending: "ממתין",
  multiRoomLineRoom: "חדר {{n}}",
  multiRoomNotChosenYet: "טרם נבחר",
  multiRoomOptionChosen: "נבחרה חבילה",
  multiRoomNoMatchingOffers:
    "לא נמצאה חבילה תואמת לחדר הפעיל ברשימה. נסו לשנות מסננים או לחזור לתוצאות החיפוש.",
  multiRoomCompleteAllHint: "יש להשלים בחירה לכל החדרים לפני המשך.",
  multiRoomListScopedHint: "האפשרויות למטה מתאימות לחדר {{n}} בלבד: {{occupancy}}",
  multiRoomStickyRegionLabel: "התקדמות הזמנה מרובת חדרים",
  multiRoomStickyProgress: "{{done}} מתוך {{total}} הושלמו",
  multiRoomStickyLineLabel: "חדר {{n}}",
  multiRoomStickySelectingNow: "בבחירה…",
  multiRoomContinueCta: "המשך להזמנה",
  multiRoomSelectForRoomN: "בחר לחדר {{n}}",
  multiRoomPickForActiveStep: "בחרו מהאפשרויות למטה עבור החדר הפעיל",
  multiRoomOccupancyUnknown: "כפי שהוגדר בחיפוש",
  multiRoomAdultsLabel: "{{count}} מבוגרים",
  multiRoomChildAgeLabel: "ילד בן {{age}}",
  multiRoomInfantsLabel: "{{count}} תינוקות",
  multiRoomOccupancySeparator: ", ",
  pleaseselect: "נא לבחור מהחדרים המוצגים למטה",
  multiRoomReviewCardHint:
    "חיפוש מרובה חדרים: השלימו את כל הבחירות למטה, ואז לחצו על ״המשך להזמנה״.",
  multiRoomSectionSubtitle:
    "אתם מזמנים מספר חדרים. בחרו חבילה אחת לכל חדר, לפי הסדר. שינוי בחירה בחדר מסוים מאפס את הבחירות בחדרים שאחריו. רענון מלא של הדף מאפס את כל הבחירות.",
  prev: "הקודם",
  next: "הבא",
};

/**
 * Translate a key under `hotelprofile.*` using i18next's keyPrefix (reliable with i18next v23+).
 * Falls back to `HOTELPROFILE_MULTIROOM_HE` when the bundle is missing or fetch failed.
 *
 * @param {import("i18next").TFunction & { i18n?: import("i18next").i18n }} t — from useTranslation()
 * @param {string} keySuffix — e.g. multiRoomOverviewLine, prev, RO
 * @param {object} [opts]
 */
export function tHotelProfileMulti(t, keySuffix, opts = {}) {
  const defaultValue = HOTELPROFILE_MULTIROOM_HE[keySuffix];
  const withDefault =
    defaultValue != null ? { ...opts, defaultValue } : { ...opts };

  const i18n = t && typeof t === "function" && t.i18n;
  if (i18n && typeof i18n.getFixedT === "function") {
    const fixed = i18n.getFixedT(i18n.language, "translation", "hotelprofile");
    return fixed(keySuffix, withDefault);
  }

  return t(`hotelprofile.${keySuffix}`, withDefault);
}

/**
 * Board / meal codes (RO, BB, …) stored as keys under hotelprofile.
 * @param {import("i18next").TFunction & { i18n?: import("i18next").i18n }} t
 * @param {string} code
 */
export function tHotelProfileCode(t, code) {
  if (!code) return "";
  const i18n = t && typeof t === "function" && t.i18n;
  if (i18n && typeof i18n.getFixedT === "function") {
    const fixed = i18n.getFixedT(i18n.language, "translation", "hotelprofile");
    return fixed(code, { defaultValue: code });
  }
  return t(`hotelprofile.${code}`, { defaultValue: code });
}
